'use client';

import { useEffect } from 'react';

// DS.Page's <main> is the scroll container on marketplace; embed scrolls the document.
const PAGE_CONTENT_SELECTOR = '[data-subcomponent="page-content"]';

export const scrollPageToTop = () => {
  const pageContent = document.querySelector(PAGE_CONTENT_SELECTOR);
  if (pageContent instanceof HTMLElement) {
    pageContent.scrollTo({ top: 0 });
    return;
  }
  document.scrollingElement?.scrollTo({ top: 0 });
};

export const useScrollPageToTop = (enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    scrollPageToTop();
  }, [enabled]);
};
